<template>
  <div class="w-full">
    <div :class="!breakpoints.lgAndDown ? 'flex' : ''">
      <el-menu
        v-if="breakpoints.lgAndUp"
        :default-active="getRouteName"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
      >
        <div class="ml-8 pt-12 pb-12"><app-logo /></div>
        <el-menu-item
          v-if="hasDashboardAccess"
          @click="goToRoute('dashboard')"
          index="1"
        >
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <dashboard-icon :active="getRouteName === '1'" />
            </div>
            <span slot="title">Dashboard</span>
          </div>
        </el-menu-item>
        <el-menu-item
          :disabled="!hasTerminalAccess"
          index="2"
          :class="!hasKyc ? 'opacity-60 cursor-not-allowed' : ''"
          @click="goToRoute('terminal')"
        >
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <terminal-icon :active="getRouteName === '2'" />
            </div>
            <span slot="title">FX Transfer</span>
          </div>
        </el-menu-item>
        <el-menu-item @click="goToRoute('transactions')" index="3">
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <transactions-icon :active="getRouteName === '3'" />
            </div>
            <span slot="title">Transactions</span>
          </div>
        </el-menu-item>
        <el-menu-item
          v-if="hasApiAccess"
          @click="goToRoute('API Management System')"
          index="4"
        >
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <external-link-icon :active="getRouteName === '4'" />
            </div>
            <span slot="title">Manage API</span>
          </div>
        </el-menu-item>
        <el-menu-item
          @click="goToRoute('Receive Payment')"
          index="5"
          v-if="hasDashboardAccess && isOnDevEnvironment"
        >
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <external-link-icon :active="getRouteName === '5'" />
            </div>
            <span slot="title">Receive Payment</span>
          </div>
        </el-menu-item>
        <el-menu-item @click="goToRoute('settings')" index="6">
          <div class="flex items-center">
            <div class="pr-3 -ml-2">
              <settings-icon :active="getRouteName === '6'" />
            </div>
            <span slot="title">Settings</span>
          </div>
        </el-menu-item>
        <div class="fixed left-0 bottom-6">
          <div class="pl-9">
            <div
              @click="toggleTheme"
              class="flex items-center justify-center gap-2.5 py-1.5 w-20 cursor-pointer rounded-3xl border-2 border-primary"
            >
              <sun-icon />
              <moon-icon />
            </div>
          </div>
          <el-menu-item @click="logout" class="logout">
            <div class="flex items-center">
              <div class="pr-2 -ml-2.5"><logout-icon /></div>
              <span class="text-red-2" slot="title">Logout</span>
            </div>
          </el-menu-item>
          <div
            class="text-xs text-black-2 font-extralight w-48 mx-2 mt-2 cursor-pointer"
          >
            <!-- <span @click="showTermsDialog"> Terms of service</span> |
            <span @click="showPrivacyDialog">Privacy Policy</span> -->
          </div>
        </div>
      </el-menu>

      <!-- for smaller screens -->
      <el-drawer
        v-else
        :visible.sync="drawer"
        direction="ltr"
        :show-close="false"
        :withHeader="false"
        size="233px"
        custom-class="menuDrawer h-screen scroll"
      >
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <div class="pb-24"></div>
          <el-menu-item
            v-if="hasDashboardAccess"
            @click="goToRoute('dashboard')"
            index="1"
          >
            <div class="flex items-center">
              <div class="pr-3 -ml-2.5">
                <dashboard-icon :active="getRouteName === '1'" />
              </div>
              <span slot="title">Dashboard</span>
            </div>
          </el-menu-item>
          <el-menu-item
            :disabled="!hasTerminalAccess"
            index="2"
            :class="!hasKyc ? 'opacity-60 cursor-not-allowed' : ''"
            @click="goToRoute('terminal')"
          >
            <div class="flex items-center">
              <div class="pr-3 -ml-2">
                <terminal-icon :active="getRouteName === '2'" />
              </div>
              <span slot="title">FX Transfer</span>
            </div>
          </el-menu-item>
          <el-menu-item @click="goToRoute('transactions')" index="3">
            <div class="flex items-center">
              <div class="pr-3 -ml-2.5">
                <transactions-icon :active="getRouteName === '3'" />
              </div>
              <span slot="title">Transactions</span>
            </div>
          </el-menu-item>
          <el-menu-item
            v-if="hasApiAccess"
            @click="goToRoute('API Management System')"
            index="4"
          >
            <div class="flex items-center">
              <div class="pr-3 -ml-2.5">
                <external-link-icon :active="getRouteName === '4'" />
              </div>
              <span slot="title">Manage API</span>
            </div>
          </el-menu-item>
          <el-menu-item
            @click="goToRoute('Receive Payment')"
            index="5"
            v-if="hasDashboardAccess && isOnDevEnvironment"
          >
            <div class="flex items-center">
              <div class="pr-3 -ml-2">
                <external-link-icon :active="getRouteName === '5'" />
              </div>
              <span slot="title">Receive Payment</span>
            </div>
          </el-menu-item>
          <el-menu-item @click="goToRoute('settings')" index="6">
            <div class="flex items-center">
              <div class="pr-3 -ml-2.5">
                <settings-icon :active="getRouteName === '6'" />
              </div>
              <span slot="title">Settings</span>
            </div>
          </el-menu-item>
          <div class="fixed left-0 bottom-6">
            <div class="pl-9">
              <div
                @click="toggleTheme"
                class="flex items-center justify-center gap-2.5 py-1.5 w-16 cursor-pointer rounded-3xl border-2 border-primary"
              >
                <sun-icon />
                <moon-icon />
              </div>
            </div>
            <el-menu-item @click="logout">
              <div class="flex items-center">
                <div class="pr-2 -ml-2.5"><logout-icon /></div>
                <span class="text-red-2" slot="title">Logout</span>
              </div>
            </el-menu-item>
            <div
              class="text-xs text-black-2 font-extralight w-48 mx-2 mt-2 cursor-pointer"
            >
              <!-- <span @click="showTermsDialog"> Terms of service</span> |
            <span @click="showPrivacyDialog">Privacy Policy</span> -->
            </div>
          </div>
          <!-- <div class="fixed left-0 bottom-6">
            <el-menu-item @click="logout" index="5">
              <div class="flex items-center">
                <div class="pr-2 -ml-2.5"><logout-icon /></div>
                <span class="text-red-2" slot="title">Logout</span>
              </div>
            </el-menu-item>
            <div
              class="text-xs text-black-2 font-extralight w-48 mx-4 mt-2 cursor-pointer"
            >
              <span @click="showTermsOfServiceDialog = true">
                Terms of service</span
              >
              | <span @click="showPrivacyDialog">Privacy Policy</span>
            </div>
          </div> -->
        </el-menu>
      </el-drawer>
      <div class="w-full min-h-screen relative bg-root-1">
        <base-header @toggle-drawer="toggleDrawer" />
        <router-view class="pb-20" />
        <div
          v-if="tenantPermission('has-footer-access')"
          class="bottom-0 absolute justify-between flex mt-2 w-full h-20"
        >
          <div
            class="ml-14 flex text-root-4 font-normal text-base items-center"
          >
            <div
              @click="showTermsOfServiceDialog = true"
              class="mr-8 hover:opacity-50 cursor-pointer text-xs md:text-base"
            >
              Terms of Service
            </div>
            <div
              @click="showPrivacyDialog"
              class="mr-8 hover:opacity-50 cursor-pointer text-xs md:text-base"
            >
              Privacy Policy
            </div>
            <div class="text-xs md:text-base">
              <a
                href="https://docs.ovalfi.com/docs"
                target="_blank"
                rel="noopener noreferrer"
                >API Documentation</a
              >
            </div>
          </div>
        </div>
      </div>
      <terms-of-service
        v-if="showTermsOfServiceDialog"
        :showDialog="showTermsOfServiceDialog"
        @closeDialog="closeDialog"
      />
      <privacy-policy
        v-if="showPrivacyPolicyDialog"
        :showPrivacyDialog="showPrivacyPolicyDialog"
        @closeDialog="closeDialog"
      />
    </div>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { WITHDRAWAL_ACCESS } from '@/utils/constants'
import logout from '@/mixins/logout.js'
import accesses from '@/mixins/app.js'
import userKinds from '@/mixins/userKinds.js'
import tenant from '@/mixins/tenant.js'
export default {
  mixins: [logout, accesses, userKinds, tenant],
  data: () => ({
    withdrawalAccess: WITHDRAWAL_ACCESS,
    breakpoints,
    drawer: false,
    showPrivacyPolicyDialog: false,
    showTermsOfServiceDialog: false
  }),
  components: {
    // ProfileIcon: () => import('@/assets/icons/ProfileIcon.vue'),
    LogoutIcon: () => import('@/assets/icons/LogoutIcon.vue'),
    TerminalIcon: () => import('@/assets/icons/TerminalIcon.vue'),
    AppLogo: () => import('@/assets/images/AppLogo.vue'),
    TransactionsIcon: () => import('@/assets/icons/TransactionsIcon.vue'),
    DashboardIcon: () => import('@/assets/icons/DashboardIcon.vue'),
    SettingsIcon: () => import('@/assets/icons/SettingsIcon.vue'),
    BaseHeader: () => import('@/components/base/Header.vue'),
    TermsOfService: () => import('@/components/base/TermsOfService.vue'),
    PrivacyPolicy: () => import('@/components/base/PrivacyPolicy.vue'),
    MoonIcon: () => import('@/assets/icons/MoonIcon.vue'),
    SunIcon: () => import('@/assets/icons/SunIcon.vue'),
    ExternalLinkIcon: () => import('@/assets/icons/ExternalLinkIcon')
  },
  computed: {
    getRouteName () {
      return this.$route.name === 'dashboard'
        ? '1'
        : this.$route.name === 'terminal'
        ? '2'
        : this.$route.name === 'transactions'
        ? '3'
        : this.$route.name === 'API Management System'
        ? '4'
        : this.$route.name === 'Receive Payment'
        ? '5'
        : this.$route.name === 'settings'
        ? '6'
        : ''
    },
    hasKyc () {
      return this.$store.state.auth.business.completedKyc
    },
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    user () {
      return this.$store.state.auth.user
    },
    userTheme () {
      return this.$store.state.common.userTheme
    },
    hasApiConfig () {
      return !!this.$store.state.auth.businessConfig.has_api_config
    },
    hasApiAccess () {
      return process.env.VUE_APP_API_ACCESS === 'true' && this.hasApiConfig
    },
    hasTerminalAccess () {
      return this.hasDepositAccess && this.hasKyc
    },
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    },
    tenantName () {
      return process.env.VUE_APP_TENANT_NAME
    },
    tenantVersion () {
      return process.env.VUE_APP_VERSION
    }
  },
  methods: {
    toggleTheme () {
      if (this.userTheme.includes('light-theme')) {
        this.setTheme('dark-theme')
      } else {
        this.setTheme('light-theme')
      }
    },
    showTermsDialog () {
      this.showTermsOfServiceDialog = true
    },
    showPrivacyDialog () {
      this.showPrivacyPolicyDialog = true
    },
    goToRoute (route) {
      this.drawer = false
      if (route === 'settings' && this.hasLimitedSettings) {
        this.$router.push('/settings/profile')
      } else {
        this.$router.push({ name: route })
      }
    },
    closeDialog () {
      this.showTermsOfServiceDialog = false
      this.showPrivacyPolicyDialog = false
    },
    handleClose () {
      // this.isCollapse = false
    },
    toggleDrawer () {
      this.drawer = true
    },
    handleOpen () {
      // this.isCollapse = true
    },
    setTheme (theme) {
      this.$store.dispatch('common/setUserTheme', theme)
      document.documentElement.className = `${theme} ${this.tenantName} ${this.tenantVersion}`
    },
    getMediaPreference () {
      const hasDarkPreference = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches
      if (hasDarkPreference) {
        return 'dark-theme'
      } else {
        return 'light-theme'
      }
    }
  },
  mounted () {
    this.setTheme(this.userTheme)
  }
}
</script>

<style></style>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
.bg-root-1 {
  background: var(--background-1);
}
.el-menu-item.is-active {
  background-color: var(--color-primary);
  color: white;
  border-radius: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.15);
}
.el-menu-vertical-demo {
  width: 233px;
  min-height: 100vh;
}
.el-menu {
  border-right: 0px;
  background: var(--background);
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.1);
}
.el-menu-item {
  color: var(--text-1);
  margin-right: 25px;
  margin-left: 25px;
  margin-top: 16px;
  margin-bottom: 20px;
  height: 45px;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
  border-radius: 30px;
}
.logout.el-menu-item {
  width: 8rem;
  margin-top: 1rem;
}
.el-menu-item:hover {
  background-color: var(--primary-gradient);
  border-radius: 30px;
  color: white;
}
.el-menu-item i {
  margin-left: -10px;
  padding-right: 8px;
}
.switch-label {
  align-items: center;
  background: var(--text-primary-color);
  border: calc(var(--element-size) * 0.025) solid var(--accent-color);
  border-radius: var(--element-size);
  cursor: pointer;
  display: flex;
  font-size: calc(var(--element-size) * 0.3);
  height: calc(var(--element-size) * 0.35);
  position: relative;
  padding: calc(var(--element-size) * 0.1);
  transition: background 0.3s ease-in-out;
  justify-content: space-between;
  width: var(--element-size);
  z-index: 1;
}

.switch-toggle {
  position: absolute;
  background-color: var(--background-color-primary);
  border-radius: 50%;
  top: calc(var(--element-size) * 0.07);
  left: calc(var(--element-size) * 0.07);
  height: calc(var(--element-size) * 0.4);
  width: calc(var(--element-size) * 0.4);
  transform: translateX(0);
  transition:
    transform 0.3s ease,
    background-color 0.5s ease;
}

.switch-toggle-checked {
  transform: translateX(calc(var(--element-size) * 0.6)) !important;
}
</style>
